import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        name: "login",
        path: "/login",
        component: () =>
            import(
                /* webpackChunkName: "login" */ "../views/pages/login/Login.vue"
            ),
    },
    {
        name: "forgot-password",
        path: "/forgot-password",
        component: () =>
            import(
                /* webpackChunkName: "forgot-password" */ "../views/pages/login/ForgotPassword.vue"
            ),
    },
    {
        name: "reset-password",
        path: "/reset-password",
        component: () =>
            import(
                /* webpackChunkName: "reset-password" */ "../views/pages/login/ResetPassword.vue"
            ),
    },
    {
        name: "confirm-email",
        path: "/confirm-email",
        component: () =>
            import(
                /* webpackChunkName: "confirm-email" */ "../views/pages/login/ConfirmEmail.vue"
            ),
    },
    {
        name: "auth-callback",
        path: "/auth/callback",
        component: () =>
            import(
                /* webpackChunkName: "auth-callback" */ "../views/pages/login/AuthCallback.vue"
            ),
    },
    {
        name: "auth-silent",
        path: "/auth/silent",
        component: () =>
            import(
                /* webpackChunkName: "auth-silent" */ "../views/pages/login/AuthSilent.vue"
            ),
    },
    {
        path: "/",
        redirect: "/dashboard",
        component: () =>
            import(
                /* webpackChunkName: "Layout" */ "../views/layout/Layout.vue"
            ),
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                component: () =>
                    import(
                        /* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Dashboard",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/miei-servizi",
                name: "miei-servizi",
                component: () =>
                    import(
                        /* webpackChunkName: "mieiServizi" */ "@/views/pages/MieiServizi/MieiServizi.vue"
                    ),
                meta: {
                    // Gate di sola UX, con lo stesso permesso della voce di menu
                    // "I miei servizi" — cioè lo stesso della voce Dashboard:
                    // dashboard / view. L'enforcement reale resta nel backend.
                    requiredPermission: {
                        controller: "dashboard",
                        action: "view",
                    },
                    breadCrumb() {
                        return [
                            {
                                text: "I miei servizi",
                                href: "/miei-servizi",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/widget-alert",
                name: "widget-alert",
                component: () =>
                    import(
                        /* webpackChunkName: "widgetAlert" */ "../views/WidgetAlert.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Widget Alert",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/amministrazione/utenti",
                name: "utenti",
                component: () =>
                    import(
                        /* webpackChunkName: "User" */ "@/views/pages/user/User.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Amministrazione",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "Utenti",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/amministrazione/utenti/dettaglio",
                name: "Nuovo Utente",
                component: () =>
                    import(
                        /* webpackChunkName: "UserDetail" */ "@/views/pages/user/detailUser.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Amministrazione",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "Utenti",
                                href: "/amministrazione/utenti/",
                                disabled: false,
                            },
                            {
                                text: "Dettaglio Utente",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/amministrazione/ruoli",
                name: "ruoli",
                component: () =>
                    import(
                        /* webpackChunkName: "Roles" */ "@/views/pages/roles/Roles.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Amministrazione",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "Ruoli",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/amministrazione/api-keys",
                name: "api-keys",
                component: () =>
                    import(
                        /* webpackChunkName: "ApiKeys" */ "@/views/pages/apikeys/ApiKeys.vue"
                    ),
                meta: {
                    // Permesso di lettura in forma controller/action, la stessa
                    // confrontata da generalFunctions.checkRolesPermissions:
                    // i permessi sono letti da currentUser.roles[].permissions
                    // (il campo piatto UserDto.Permissions non è popolato).
                    // Stessa convenzione dei meta requiresRole/requiredLicenseFeature:
                    // la verifica va fatta nel beforeEach di src/main.js.
                    // Controllo di sola UX: l'enforcement reale resta nel backend
                    // (policy apikeysview), che continua a rispondere 403.
                    requiredPermission: { controller: "apikeys", action: "view" },
                    breadCrumb() {
                        return [
                            {
                                text: "Amministrazione",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "API Key",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/amministrazione/documentazione-api",
                name: "documentazione-api",
                component: () =>
                    import(
                        /* webpackChunkName: "ApiDocs" */ "@/views/pages/apidocs/ApiDocs.vue"
                    ),
                meta: {
                    // Stesso permesso della gestione API key: chi crea le chiavi consegna agli
                    // sviluppatori esterni anche la documentazione. Controllo di sola UX:
                    // l'enforcement reale è la policy apikeysview di ApiDocsController.
                    requiredPermission: { controller: "apikeys", action: "view" },
                    breadCrumb() {
                        return [
                            {
                                text: "Amministrazione",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "Documentazione API",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/amministrazione/permessi",
                name: "permessi",
                component: () =>
                    import(
                        /* webpackChunkName: "Permissions" */ "@/views/pages/permissions/Permissions.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Amministrazione",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "Permessi",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/rubrica",
                name: "rubrica",
                component: () =>
                    import(
                        /* webpackChunkName: "Rubrica" */ "@/views/pages/rubrica/Rubrica.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Rubrica",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/rubrica/dettaglio",
                name: "Nuovo Contatto",
                component: () =>
                    import(
                        /* webpackChunkName: "ContactDetail" */ "@/views/pages/rubrica/detailRubrica.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Rubrica",
                                href: "/rubrica",
                                disabled: false,
                            },
                            {
                                text: "Dettaglio Contatto",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/clienti",
                name: "clienti",
                component: () =>
                    import(
                        /* webpackChunkName: "Clienti" */ "@/views/pages/clients/Clients.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Clienti",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/clienti/dettaglio",
                name: "Nuovo Cliente",
                component: () =>
                    import(
                        /* webpackChunkName: "ClientDetail" */ "@/views/pages/clients/detailClient.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Cliente",
                                href: "/cliente",
                                disabled: false,
                            },
                            {
                                text: "Dettaglio Cliente",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/account-pec",
                name: "Account Pec",
                component: () =>
                    import(
                        /* webpackChunkName: "AccountPec" */ "@/views/pages/accountPec/AccountPec.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Account Pec",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/account-pec/dettaglio",
                name: "Nuovo Account Pec",
                component: () =>
                    import(
                        /* webpackChunkName: "AccountPecDetail" */ "@/views/pages/accountPec/detailAccountPec.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Account Pec",
                                href: "/account-pec",
                                disabled: false,
                            },
                            {
                                text: "Dettaglio Account Pec",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },

            {
                path: "/caselle-virtuali",
                name: "Caselle Virtuali",
                component: () =>
                    import(
                        /* webpackChunkName: "MailVirtuali" */ "@/views/pages/MailVirtuali/MailVirtuali.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Caselle Virtuali",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/caselle-virtuali/dettaglio",
                name: "Nuova Mail Virtuale",
                component: () =>
                    import(
                        /* webpackChunkName: "MailVirtualiDetail" */ "@/views/pages/MailVirtuali/detailMailVirtuali.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Caselle Virtuali",
                                href: "/caselle-virtuali",
                                disabled: false,
                            },
                            {
                                text: "Dettaglio Caselle Virtuali",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },

            {
                path: "/mailbox",
                name: "Mailbox",
                component: () =>
                    import(
                        /* webpackChunkName: "Mailbox" */ "@/views/pages/Mailbox/Mailbox.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Mailbox",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/operazioni-straordinarie",
                name: "operazioni-straordinarie",
                component: () =>
                    import(
                        /* webpackChunkName: "operazioniStraordinarie" */ "../views/OperazioniStraordinarie.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Operazioni Straordinarie",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/massive/invio-massivo",
                name: "invio-massivo",
                component: () =>
                    import(
                        /* webpackChunkName: "InviaMassive" */ "../views/pages/InviaMassive/InviaMassive.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Massive",
                                href: "/",
                                disabled: false,
                            },
                            {
                                text: "Invio Massivo",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/massive/elenco-invii",
                name: "elenco-invii",
                component: () =>
                    import(
                        /* webpackChunkName: "ElencoInvii" */ "../views/pages/Massive/ElencoInvii.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Massive",
                                href: "/",
                                disabled: false,
                            },
                            {
                                text: "Elenco invii",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            // Redirect old route for backwards compatibility
            {
                path: "/invia-massive",
                redirect: "/massive/invio-massivo"
            },
            {
                path: "/massive/importazione-pst",
                name: "importazione-pst",
                component: () =>
                    import(
                        /* webpackChunkName: "PstImport" */ "../views/pages/PstImport/PstImport.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Massive",
                                href: "/",
                                disabled: false,
                            },
                            {
                                text: "Importazione PST",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/regole",
                name: "Regole",
                component: () =>
                    import(
                        /* webpackChunkName: "Regole" */ "@/views/pages/rules/Rules.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Rules",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/regole/dettaglio",
                name: "Nuova Regola",
                component: () =>
                    import(
                        /* webpackChunkName: "RuleDetail" */ "@/views/pages/rules/detailRules.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Regole",
                                href: "/regole",
                                disabled: false,
                            },
                            {
                                text: "Nuova Regola",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/deleghe",
                name: "Deleghe",
                component: () =>
                    import(
                        /* webpackChunkName: "Deleghe" */ "@/views/pages/deleghe/Deleghe.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Deleghe",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/deleghe/dettaglio",
                name: "Nuova Delega",
                component: () =>
                    import(
                        /* webpackChunkName: "DelegaDetail" */ "@/views/pages/deleghe/detailDeleghe.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Deleghe",
                                href: "/deleghe",
                                disabled: false,
                            },
                            {
                                text: "Nuova Delega",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/ricerca-operazioni",
                name: "RicercaOperazioni",
                component: () =>
                    import(
                        /* webpackChunkName: "RicercaOperazioni" */ "@/views/pages/ricercaOperazioni/RicercaOperazioni.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "RicercaOperazioni",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/listini",
                name: "Listini",
                component: () =>
                    import(
                        /* webpackChunkName: "Listini" */ "@/views/pages/Listini/Listini.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Servizi attivi",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/listini-base",
                name: "ListinoBase",
                component: () =>
                    import(
                        /* webpackChunkName: "ListinoBase" */ "@/views/pages/ListiniBase/ListiniBase.vue"
                    ),
                meta: {
                    // Gate di sola UX, come per la rotta api-keys: la pagina
                    // segue il permesso della voce di menu (listini / view) e
                    // l'enforcement reale resta nel backend
                    // ([ControllerPermission("listini", Admin)] -> 403).
                    requiredPermission: { controller: "listini", action: "view" },
                    breadCrumb() {
                        return [
                            {
                                text: "Listino base",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/fatturazione",
                name: "Fatturazione",
                component: () =>
                    import(
                        /* webpackChunkName: "Fatturazione" */ "@/views/pages/Fatturazione/Fatturazione.vue"
                    ),
                meta: {
                    // Il backend ha reso tutte le action di FatturazioneController
                    // accessibili solo a un superadmin (403 per chiunque altro):
                    // la rotta riusa il meta requiresRole già letto dalla guardia
                    // in main.js, come la rotta superadmin/utenti-online.
                    requiresRole: "superadmin",
                    breadCrumb() {
                        return [
                            {
                                text: "Fatturazione",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/servizi",
                name: "Servizi",
                component: () =>
                    import(
                        /* webpackChunkName: "Servizi" */ "@/views/pages/Servizi/Servizi.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Servizi",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/sicurezza",
                name: "Sicurezza",
                component: () =>
                    import(
                        /* webpackChunkName: "Security" */ "@/views/pages/security/Security.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Profilo",
                                href: null,
                                disabled: false,
                            },
                            {
                                text: "Sicurezza",
                                href: "/sicurezza",
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/comming-soon",
                name: "Comming Soon ...",
                component: () =>
                    import(
                        /* webpackChunkName: "CommingSoon" */ "@/views/pages/CommingSoon.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Res",
                                href: null,
                                disabled: true,
                            },
                            {
                                text: "Comming Soon",
                                href: "/",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
            {
                path: "/conservazione",
                name: "conservazioni",
                component: () =>
                    import(
                        /* webpackChunkName: "Conservazioni" */ "@/views/pages/Conservazione/Index.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Conservazione",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/conservazione/andamento",
                name: "conservazione-andamento",
                component: () =>
                    import(
                        /* webpackChunkName: "ConservazioneAndamento" */ "@/views/pages/Conservazione/Andamento.vue"
                    ),
                meta: {
                    breadCrumb() {
                        return [
                            {
                                text: "Conservazione",
                                href: "/conservazione",
                                disabled: false,
                            },
                            {
                                text: "Andamento",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/novita",
                name: "Novita",
                component: () =>
                    import(
                        /* webpackChunkName: "Novita" */ "@/views/pages/novita/Novita.vue"
                    ),
                meta: {
                    requiredLicenseFeature: "NOVITA",
                    breadCrumb() {
                        return [
                            {
                                text: "Novita",
                                href: null,
                                disabled: false,
                            },
                        ];
                    },
                },
            },
            {
                path: "/superadmin/utenti-online",
                name: "utenti-online",
                component: () =>
                    import(
                        /* webpackChunkName: "OnlineUsers" */ "@/views/pages/superadmin/OnlineUsers.vue"
                    ),
                meta: {
                    requiresRole: "superadmin",
                    breadCrumb() {
                        return [
                            {
                                text: "Superadmin",
                                disabled: false,
                                href: null,
                            },
                            {
                                text: "Utenti Online",
                                href: "/superadmin/utenti-online",
                                disabled: true,
                            },
                        ];
                    },
                },
            },
        ],
    },
];
const router = new VueRouter({
    mode: "history",
    routes,
});

export default router;
